import React from 'react'
/*
import * as pathname from './pathname'
import { MODULES, GROUPS, METHOD } from '../../utils/constants/roles'
import User from '../../views/users/user/User'
import UserJobInfo from '../../views/users/user/UserJobInfo'
import UserPrivateInfo from '../../views/users/user/UserPrivateInfo'
import UserSettingsRRHH from '../../views/users/user/UserSettingsRRHH'
*/
const userRoutes = [] /*[
    {
        path: pathname.userPathname.USER(':id'),
        name: 'User',
        element: <User />,
        role: { module: MODULES.USERS, group: GROUPS.BASIC_INFO, method: METHOD.GET }
    },
    {
        path: pathname.userPathname.USER_JOB_INFO(':id'),
        name: 'UserJobInfo',
        element: <UserJobInfo />,
        role: { module: MODULES.USERS, group: GROUPS.BASIC_INFO, method: METHOD.GET }
    },
    {
        path: pathname.userPathname.USER_PRIVATE_INFO(':id'),
        name: 'UserPrivateInfo',
        element: <UserPrivateInfo />,
        role: { module: MODULES.USERS, group: GROUPS.BASIC_INFO, method: METHOD.GET }
    },
    {
        path: pathname.userPathname.USER_SETTINGS_RRHH(':id'),
        name: 'UserSettingsRRHH',
        element: <UserSettingsRRHH />,
        role: { module: MODULES.USERS, group: GROUPS.BASIC_INFO, method: METHOD.GET }
    }
]*/

export default userRoutes
